import React from 'react';
import styles from './HintsByServiceCompanyAndType.module.scss';
import { Hint } from '../Hint/Hint';
import { HintByServiceCompany } from './components/HintByServiceCompany/HintByServiceCompany';
import { HintByRequestType } from './components/HintByRequestType/HintByRequestType';
import { useIsDispatcher } from '../../../../../../hooks/useIsDispatcher';

export const HintsByServiceCompanyAndType = ({
  setVisible,
  hintsByServiceCompany = [],
  hintsByRequestType = [],
}) => {
  const isDispatcher = useIsDispatcher();

  return (
    <Hint
      setVisible={setVisible}
      title="Подсказки"
      render={() => {
        return (
          <div className={styles.root}>
            <HintByServiceCompany
              hints={hintsByServiceCompany}
              withPhoneLinks={isDispatcher}
            />
            <HintByRequestType
              hints={hintsByRequestType}
              withPhoneLinks={isDispatcher}
            />
          </div>
        );
      }}
    />
  );
};
